import React, { useEffect, useRef } from 'react';
import { SearchEventCardStyleSwitcher } from '../../../../components/EventCard';
import { SearchEventCardProps } from '../../../../types';

interface ISearchPrimaryResultsEventCardWrapper extends SearchEventCardProps {
    id: string;
    results: undefined;
    isRaised: boolean;
    scrollId?: string;
    setHoverEventTarget: Function;
}

export const SearchPrimaryResultsEventCardWrapper: React.FunctionComponent<ISearchPrimaryResultsEventCardWrapper> =
    React.memo((props) => {
        const { scrollId, id, setHoverEventTarget } = props;
        const cardRef = useRef<HTMLDivElement>(null);

        useEffect(() => {
            if (scrollId === id && cardRef.current) {
                cardRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, [scrollId, id]);

        return (
            <div
                className="search-event-card-wrapper"
                onMouseEnter={() => setHoverEventTarget(id)}
                onFocus={() => setHoverEventTarget(id)}
                onMouseLeave={() => setHoverEventTarget(null)}
                onBlur={() => setHoverEventTarget(null)}
                role="presentation"
                ref={cardRef}
            >
                <SearchEventCardStyleSwitcher {...props} />
            </div>
        );
    }, areEqual);

function areEqual(
    prevProps: ISearchPrimaryResultsEventCardWrapper,
    nextProps: ISearchPrimaryResultsEventCardWrapper,
) {
    //return true if no re-render
    //return false if should re-render
    if (
        prevProps.dedup !== nextProps.dedup ||
        prevProps.isRaised !== nextProps.isRaised ||
        (nextProps.scrollId === nextProps.id && !prevProps.scrollId) ||
        prevProps.organizerName !== nextProps.organizerName
    ) {
        return false;
    }

    return true;
}
